import Link from "next/link";
import React from "react";
import { collectionPath } from "../../lib/collectionUrls";
import StoreItem from "../StoreItem";

/**
 * Component to display a collection with its products in a horizontal scrollable list
 *
 * @param {Object} props - Component props
 * @param {string} props.collectionTitle - Title of the collection
 * @param {string} [props.collectionHandle] - URL handle of the collection
 * @param {Array} props.productsData - Array of products in the collection
 */
const FeaturedCollectionWithProd = ({ collectionTitle, collectionHandle, productsData }) => {
  const products = productsData || [];

  if (products.length === 0) {
    return null;
  }

  const formattedCollectionName = collectionTitle?.toLowerCase() || "";
  const collectionUrl = collectionPath({ handle: collectionHandle, title: collectionTitle });

  // V1 homepage is always a 2-column grid. theme.collectionScrollDirection is ignored here.
  const isVerticalScroll = true;

  return (
    <div className="px-5">
      <h2 className="mt-8 text-lg font-normal capitalize tracking-[0.5px] text-checkoutText">
        Shop {formattedCollectionName}
      </h2>

      {isVerticalScroll ? (
        // Vertical grid layout
        <div className="mt-4 grid grid-cols-2 gap-4">
          {products.map((product) => (
            <StoreItem key={product.id} product={product} pageSize={products.length} />
          ))}
        </div>
      ) : (
        // Horizontal scroll layout
        <div className="hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap">
          {products.map((product) => (
            <StoreItem
              usedForCollectionhome={true}
              key={product.id}
              product={product}
              pageSize={products.length}
            />
          ))}
        </div>
      )}

      <Link href={collectionUrl}>
        <a className="mx-auto mt-4 block w-fit rounded-full border border-mutedInk px-3.5 py-2.5 text-center text-[11px] font-medium capitalize text-mutedInk">
          Shop {formattedCollectionName}
        </a>
      </Link>
    </div>
  );
};

export default FeaturedCollectionWithProd;
